/**
 * Unavailable color swatch indicator
 * Upload as: assets/unavailable-swatches.js
 * Then add to your main-product.liquid (before </div> at bottom):
 *   <script src="{{ 'unavailable-swatches.js' | asset_url }}" defer></script>
 *
 * What it does:
 * - On page load, checks which colors have NO available variant for the
 *   currently selected size, and marks them with a red diagonal strike.
 * - Re-checks whenever the selected size changes.
 * - Also works in reverse: when a color is selected, marks unavailable sizes.
 */

(function () {
  'use strict';

  /* ── inject styles once ── */
  var style = document.createElement('style');
  style.textContent = `
    /* Unavailable SIZE label (already set via CSS, kept here as fallback) */
    input.disabled + label {
      color: #c0392b !important;
      opacity: 0.6;
      cursor: not-allowed !important;
      pointer-events: none;
      text-decoration: line-through;
    }

    /* Unavailable COLOR swatch */
    label.swatch--unavailable {
      opacity: 0.5;
      cursor: not-allowed !important;
      pointer-events: none;
      position: relative;
    }

    /* Red diagonal line across the swatch circle */
    label.swatch--unavailable::after {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(
        to bottom right,
        transparent calc(50% - 1px),
        #c0392b calc(50% - 1px),
        #c0392b calc(50% + 1px),
        transparent calc(50% + 1px)
      );
      border-radius: 50%;
      pointer-events: none;
      z-index: 2;
    }
  `;
  document.head.appendChild(style);

  function init() {
    var variantRadios = document.querySelector('variant-radios');
    if (!variantRadios) return;

    /* parse variant data */
    var variantData = [];
    try {
      var json = variantRadios.querySelector('[data-variant]');
      if (json) variantData = JSON.parse(json.textContent);
    } catch (e) { return; }

    if (!variantData.length) return;

    /* fieldsets */
    var colorFieldset = variantRadios.querySelector('.variant--swatch-option1');
    var sizeFieldset  = variantRadios.querySelector('.variant--swatch-option2');
    if (!colorFieldset || !sizeFieldset) return;

    function getCheckedValue(fieldset) {
      var checked = fieldset.querySelector('input:checked');
      return checked ? checked.value : null;
    }

    function updateColorAvailability() {
      var selectedSize = getCheckedValue(sizeFieldset);
      if (!selectedSize) return;

      colorFieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var colorValue = input.value;
        var label = colorFieldset.querySelector('label[for="' + input.id + '"]');
        if (!label) return;

        /* check if ANY variant with this color + selected size is available */
        var hasAvailable = variantData.some(function (v) {
          return v.option1 === colorValue &&
                 v.option2 === selectedSize &&
                 v.available === true;
        });

        if (hasAvailable) {
          label.classList.remove('swatch--unavailable');
          input.disabled = false;
        } else {
          label.classList.add('swatch--unavailable');
          input.disabled = true;
        }
      });
    }

    function updateSizeAvailability() {
      var selectedColor = getCheckedValue(colorFieldset);
      if (!selectedColor) return;

      sizeFieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var sizeValue = input.value;
        var label = sizeFieldset.querySelector('label[for="' + input.id + '"]');
        if (!label) return;

        var hasAvailable = variantData.some(function (v) {
          return v.option1 === selectedColor &&
                 v.option2 === sizeValue &&
                 v.available === true;
        });

        if (hasAvailable) {
          input.classList.remove('disabled');
          label.style.color = '';
          label.style.textDecoration = '';
          label.style.opacity = '';
          label.style.pointerEvents = '';
          label.style.cursor = '';
        } else {
          input.classList.add('disabled');
        }
      });
    }

    /* run on size change → update colors */
    sizeFieldset.addEventListener('change', function () {
      updateColorAvailability();
    });

    /* run on color change → update sizes */
    colorFieldset.addEventListener('change', function () {
      updateSizeAvailability();
    });

    /* initial run */
    updateColorAvailability();
    updateSizeAvailability();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();
